module.exports = __webpack_public_path__ + "static/media/img1.3ac4bbce.jpg";